<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >

    <path
      d="M10.25 10.375L12.6664 12.7615C14.0009 14.0795 16.1646 14.0795 17.4991 12.7615C18.8336 11.4435 18.8336 9.30655 17.4991 7.98851C16.1646 6.6705 14.0009 6.6705 12.6664 7.98851L10.25 10.375ZM10.25 10.375L7.83363 7.98851C6.49911 6.6705 4.33542 6.6705 3.00089 7.98851C1.66637 9.30655 1.66637 11.4435 3.00089 12.7615C4.33542 14.0795 6.49911 14.0795 7.83363 12.7615L10.25 10.375Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
    /></svg>
</template>

<script>
export default {
  name: 'InfiniteIcon',
  props: {
    width: {
      type: Number,
      default: 28
    },
    height: {
      type: Number,
      default: 28
    }
  }
}
</script>

<style scoped></style>
